import _ from 'lodash'

export const handleExceptPath = (location) => {
  const pathname = _.get(location, 'pathname', '')

  return (
    pathname.includes('/consent') ||
    pathname.includes('/logging-in') ||
    pathname.includes('/location') ||
    pathname.includes('/waiting-for-login') ||
    pathname.includes('/login') ||
    pathname.includes('/switch-from-backend')
  )
}

export const handleDmsExceptPath = (location) => {
  const pathname = _.get(location, 'pathname', '')

  return (
    pathname.includes('/logging-in') ||
    pathname.includes('/login') ||
    pathname.includes('/waiting-for-login') ||
    pathname === '/'
  )
}
